import Chemistry from "./containers/chemistry";

export default Chemistry;